export default function ITCoreProceduresDirective() {
  return {
    template: require('./it-core-procedures.html'),
    scope: {
      assessmentItCoreProcedures: '=',
      status: '=',
      canEdit: '<',
    },
    controller: 'ITCoreProceduresController',
    controllerAs: 'itCoreProceduresVM',
    bindToController: true,
    replace: true,
  };
}
